import {QueryClient} from 'react-query';

import fetch, {NetworkError} from 'utils/fetch';
import {buildAPIURL, Slash, withParams} from 'utils/url';
import {isObject} from 'utils/object';

const isURL = value => value.indexOf(Slash) >= 0;

const getURL = (queryKey, pageParam) => {
    if (pageParam) return pageParam;

    const lastIndex = queryKey.length - 1;
    const lastPart = queryKey[lastIndex];
    const [firstPart] = queryKey;

    let parts = queryKey;
    let params = null;

    if (isObject(lastPart)) {
        parts = queryKey.slice(0, lastIndex);
        params = lastPart;
    }

    let baseURL;

    if (parts.length === 1 && isURL(firstPart)) {
        baseURL = firstPart;
    } else {
        baseURL = buildAPIURL(...parts);
    }

    return params ? withParams(baseURL, params) : baseURL;
};

export const defaultRetry = (failureCount, error) => error instanceof NetworkError && failureCount < 5;

export const getQueryClient = credentials => new QueryClient({
    defaultOptions: {
        queries: {
            retry: defaultRetry,
            queryFn({queryKey, pageParam, meta, signal}) {
                const url = getURL(queryKey, pageParam);
                const options = {credentials, signal, ...meta};

                return fetch(url, options);
            },
        },
    },
});

export default getQueryClient('same-origin');
